export const BASE_URL =
  process.env.REACT_APP_ENV === 'staging' ? 'https://us-central1-meny-stag.cloudfunctions.net/api/' : 'https://us-central1-lynked-demo-tryout.cloudfunctions.net/api/';
export const VAPID_KEY_STAG = 'BL9gHxG9pP7aBBOOe0WPZaBzmfVzwb37M5ri0dN-BQx6BuC_hSxKUESJ9ZYqnFXomHFBd2P97O7di0sqLdggYYM';
export const VAPID_KEY_PROD = 'BDsxMM2y-xzqJRjV__rkQrxjvEYSNSgVSbkpv_VFYAHy3FLsIauU2u0Impyy4_Va_e9y68BOTRL3lT1qMh5aQ0s';
